import { render } from "./SetNewPassword.vue?vue&type=template&id=2899837d&scoped=true"
import script from "./SetNewPassword.vue?vue&type=script&lang=js"
export * from "./SetNewPassword.vue?vue&type=script&lang=js"

import "./SetNewPassword.vue?vue&type=style&index=0&id=2899837d&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2899837d"]])

export default __exports__